import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Select from 'react-select';
import RequestItemIcon from './RequestItemIcon';
import { fetchEngineerStockDetails } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { useHistory } from 'react-router-dom';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

function EngineerStockIndex() {
    const [data, setData] = useState([]);
    const [requestDialogOpen, setRequestDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [requestText, setRequestText] = useState('');
    const history = useHistory();

    const { isAuthenticated, companyId, permissions, token, userId, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, userId, logout]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchEngineerStockDetails('EngineerStockApi', companyId, userId, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    console.log(response);
                } else {
                    const responses = await fetchEngineerStockDetails('EngineerStockApi', companyId, userId, token);
                    if (responses.responseCode === '1111') {
                        setData(responses.response_data);
                    }
                }
            } catch (error) {
                console.error('Error occurred while fetching data:', error);
            }
        };

        fetchData();
    }, [companyId, userId, token]);


    //REQUEST

    const handleRequest = (itemId, name, spareId, engineerId) => {
        setSelectedItem({ id: itemId, name: name, spareId: spareId, engineerId: engineerId });
        setRequestDialogOpen(true);
    };

    const handleCloseRequestDialog = () => {
        setSelectedItem(null);
        setRequestText('');
        setRequestDialogOpen(false);
    };


    //const API_URL = 'https://localhost:7291/api/EngineerStockTransferApi';
    const API_URL = 'https://pp-api.off-ease.com/api/EngineerStockTransferApi';


    const handleSubmitRequest = async () => {
        try {
            const request = {
                SparePartsID: selectedItem.spareId,
                EngineerStockID: selectedItem.id,
                StaffID: selectedItem.engineerId,
                CompanyID: companyId,
                Quantity: parseFloat(requestText),
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                Date: new Date().toISOString(),
                IsRequest: true,
                IsReturned: false,
                IsPurschased: false,
                IsClaimed: false,
                IsFinished: false,
            };

            const response = await axios.post(API_URL, request);
            console.log('Transfer submitted successfully:', response.data);
            window.location.reload();
        } catch (error) {
            console.error('Error submitting transfer:', error);
        }
        console.log('Request Text:', requestText);
        handleCloseRequestDialog();
    };


    // RETURN
    const [returnDialogOpen, setReturnDialogOpen] = useState(false);
    const [returnText, setReturnText] = useState('');

    const handleReturn = (itemId, name, spareId, engineerId) => {
        setSelectedItem({ id: itemId, name: name, spareId: spareId, engineerId: engineerId });
        setReturnDialogOpen(true);
    };

    const handleCloseReturnDialog = () => {
        setSelectedItem(null);
        setReturnDialogOpen(false);
    };

    const handleSubmitReturn = async () => {
        try {
            const request = {
                SparePartsID: selectedItem.spareId,
                EngineerStockID: selectedItem.id,
                StaffID: selectedItem.engineerId,
                CompanyID: companyId,
                Quantity: parseFloat(returnText),
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                Date: new Date().toISOString(),
                IsReturned: true
            };


            const response = await axios.post(API_URL, request);
            console.log('Return submitted successfully:', response.data);

            window.location.reload();
        } catch (error) {
            console.error('Error submitting return:', error);
        }

        console.log('Return Text:', returnText);
        handleCloseReturnDialog();
    };

    // purchase 


    const [purchaseDialogOpen, setPurchaseDialogOpen] = useState(false);
    const [purchaseText, setPurchaseText] = useState('');

    // Function to handle purchase request
    const handlePurchase = (itemId, name, spareId, engineerId) => {
        setSelectedItem({ id: itemId, name: name, spareId: spareId, engineerId: engineerId });
        setPurchaseDialogOpen(true);
    };

    // Function to close purchase dialog
    const handleClosePurchaseDialog = () => {
        setSelectedItem(null);
        setPurchaseText('');
        setPurchaseDialogOpen(false);
    };

    // Function to submit purchase request
    const handleSubmitPurchase = async () => {
        try {
            const request = {
                SparePartsID: selectedItem.spareId,
                EngineerStockID: selectedItem.id,
                StaffID: selectedItem.engineerId,
                CompanyID: companyId,
                Quantity: parseFloat(purchaseText),
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                Date: new Date().toISOString(),
                IsPurchased: true,
                IsReturned: false,

            };

            const response = await axios.post(API_URL, request);
            console.log('Purchase submitted successfully:', response.data);
            window.location.reload();
        } catch (error) {
            console.error('Error submitting purchase:', error);
        }

        console.log('Purchase Text:', purchaseText);
        handleClosePurchaseDialog();
    };

    //Spare-Parts Purcahse By Engineer 
    const [spareByEngOptions, setSpareByEngOptions] = useState([]);
    const [selectedSpareByEng, setSparePurchasedByEng] = useState("");

    const fetchSpareByEng = async () => {
        try {
            const response = await fetchEngineerStockDetails('EngineerStockApi', companyId, userId, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(type => ({
                    value: type.name,
                    label: type.Id
                }));
                setSpareByEngOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Request Types:', error);
        }
    };

    const handleSpareByEngChange = (selectedOption) => {
        setSparePurchasedByEng(selectedOption);
    };

    useEffect(() => {
        fetchSpareByEng();
    }, []);

    //search
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>STOCK</h6>

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
            </div>
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', color: 'white', textTransform: 'uppercase' }}>Spare</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', color: 'white', textTransform: 'uppercase' }}>Bal.Qty</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {/* {data.map((item, index) => ( */}
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc' }}>{item.spareName}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.balanceQuantity}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc' }}>
                                        <Tooltip title="Request">
                                            <IconButton aria-label="request" onClick={() => handleRequest(item.id, item.spareName, item.sparePartsID, item.engineerID)} style={{ marginRight: '10px' }}>
                                                <RequestItemIcon style={{ color: '#FF0800' }} /><label>Request</label>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Return">
                                            <IconButton aria-label="return" onClick={() => handleReturn(item.id, item.spareName, item.sparePartsID, item.engineerID)}>
                                                <UndoOutlinedIcon style={{ color: '#50C878' }} /><label>Return</label>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Purchased">
                                            <IconButton aria-label="purchased" onClick={() => handlePurchase(item.id, item.spareName, item.sparePartsID, item.engineerID)}>
                                                <AddShoppingCartIcon style={{ color: '#008080' }} /><label>Purchase</label>
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Dialog for Request */}
            <Dialog open={requestDialogOpen} onClose={handleCloseRequestDialog}>
                <DialogTitle>{selectedItem && selectedItem.name}</DialogTitle>
                <DialogContent>
                    <h6 style={{ color: 'darkred' }}>Request Item Quantity</h6>
                    {/* <input
                        type="number"
                        placeholder="Enter your request"
                        value={requestText}
                        onChange={(e) => setRequestText(e.target.value)}
                        style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
                        min="0"
                        maxLength={2}
                    /> */}
                    <input
                        value={requestText}
                        onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, '');
                            if (input.length <= 2) {
                                setRequestText(input);
                            }
                        }}
                        type="text"
                        placeholder="Enter your request"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseRequestDialog} color="secondary">Cancel</Button>
                    <Button onClick={handleSubmitRequest} color="primary">Submit</Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for Return */}
            <Dialog open={returnDialogOpen} onClose={handleCloseReturnDialog}>
                <DialogTitle>{selectedItem && selectedItem.name}</DialogTitle>
                <DialogContent>
                    <h6 style={{ color: 'darkgreen' }}>Return Item Quantity</h6>
                    {/* <input
                        type="number"
                        placeholder="Enter return quantity"
                        value={returnText}
                        onChange={(e) => setReturnText(e.target.value)}
                        style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
                        min="0"
                        maxLength={2}
                    /> */}
                    <input
                        value={returnText}
                        onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, '');
                            if (input.length <= 2) {
                                setReturnText(input);
                            }
                        }}
                        type="text"
                        placeholder="Enter return quantity"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseReturnDialog} color="secondary">Cancel</Button>
                    <Button onClick={handleSubmitReturn} color="primary">Submit</Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for Purcahse Spare */}
            <Dialog open={purchaseDialogOpen} onClose={handleClosePurchaseDialog}>
                <DialogTitle>{selectedItem && selectedItem.name}</DialogTitle>
                <DialogContent>
                    <h6 style={{ color: 'darkolivegreen' }}>Purchased Item Quantity</h6>
                    {/* <input
                        type="number"
                        placeholder="Purchase Qty"
                        value={purchaseText}
                        onChange={(e) => setPurchaseText(e.target.value)}
                        style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
                        min="0"
                        maxLength="2" 
                    /> */}
                    <input
                        value={purchaseText}
                        onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, '');
                            if (input.length <= 2) {
                                setPurchaseText(input);
                            }
                        }}
                        type="text"
                        placeholder="Purchase Qty"
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePurchaseDialog} color="secondary">Cancel</Button>
                    <Button onClick={handleSubmitPurchase} color="primary">Submit</Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}

export default EngineerStockIndex;
